<template>
  <div class="row">
      <div class="col-md-12">
        <ServiceForm :isNewService=true>
        </ServiceForm>
      </div>
  </div>
</template>

<script>
import RouterCheck from '@/mixins/RouterCheck';
import ServiceForm from '../components/service/ServiceForm.vue';

export default {
  name: 'NewService',
  components: {
    ServiceForm,
  },
  mixins: [RouterCheck],
};
</script>
